var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webPage df cf", attrs: { id: "app" } },
    [
      _c("router-view", { ref: "childrenRouter" }),
      _vm._v(" "),
      _vm.isShowLoad
        ? _c("div", { staticClass: "load df wao hao" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowKalert
        ? _c("div", { staticClass: "kAlert df wao hao" }, [
            _c("div", { staticClass: "kAlert-box" }, [
              _c("div", { staticClass: "kAlert-txt df wao" }, [
                _vm._v(_vm._s(_vm.kalertTxt))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "kAlert-end df wao hao" }, [
                _c(
                  "div",
                  { staticClass: "kAlert-btn", on: { click: _vm.closeKalert } },
                  [_vm._v("确定")]
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loadArea" }, [
      _c("div", { staticClass: "loadCircle" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ecaa44a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ecaa44a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/index.vue
// module id = null
// module chunks = 